import { useEffect, useState } from 'react'
import styles from './PlatformManagementPage.module.css'
import Navbar from '../../components/Navbar/Navbar'
import EventsList from '../../components/EventsList/EventsList'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import plusIcon from '../../assets/icons/plus.svg'
import { EventType } from '../MainPage/MainPage'
import SearchPanel from '../../components/SearchPanel/SearchPanel'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { getPlaces, getPlacesFromCompany } from '../../redux/actions/placesAction'
import Loader from '../../components/UI/Loader/Loader'
import { PlaceType } from '../../redux/actions/types'
import { useLocation } from 'react-router-dom'
import { placesPerPage } from '../../constants/constants'
import CustomModal from '../../components/UI/CustomModal/CustomModal'
import CreatePlatform from '../../components/CreatePlatform/CreatePlatform'
import { useMediaQuery } from 'react-responsive'

const PlatformManagementPage = () => {
  const [currentPage, setCurrentPage] = useState(1)

  const dispatch = useAppDispatch()
  const location = useLocation()
  const [modal, setModal] = useState(false)
  const { isLoading, places } = useAppSelector((state) => state.places)
  const { token, userRole, user } = useAppSelector((state) => state.auth)
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })
  const dummyData = (array: PlaceType[]) => {
    const items: EventType[] = array.map((place) => {
      return {
        id: place.id,
        title: place.name,
        subTitle: place.company.name,
        numberOfPerson: String(place.size),
        images: place.images.map((p, index) => {
          return { id: index, src: `${process.env.REACT_APP_BASE_URL_IMAGES}${p}` }
        }),
      }
    })
    return items
  }

  const eventList = dummyData(places.places)

  useEffect(() => {
    if (location.state) {
      dispatch(
        getPlaces({
          token,
          page: currentPage,
          itemsPerPage: placesPerPage,
          city: location.state.city,
          peopleCount: location.state.guestsNumber,
          startDate: location.state.startDate,
          endDate: location.state.finishDate,
        }),
      )
    } else {
      if (
        userRole === 'directorPlace' ||
        userRole === 'employeePlace' ||
        userRole === 'directorAgent'
      ) {
        dispatch(
          getPlacesFromCompany({
            token,
            page: currentPage,
            itemsPerPage: placesPerPage,
            companyId: String(user.employee?.company?.id),
          }),
        )
      } else {
        dispatch(getPlaces({ token, page: currentPage, itemsPerPage: placesPerPage }))
      }
    }
  }, [dispatch, currentPage, setCurrentPage, placesPerPage])

  return (
    <div className={styles.mainPage}>
      <Navbar />

      <div className={styles.content}>
        <div className={styles.header}>
          <div>
            <h1 className={styles.title}>
              {location?.state?.titlePage ? location?.state?.titlePage : 'Залы'}
            </h1>
            <p className={styles.description}>Все залы</p>
          </div>

          {userRole !== 'employeeAgent' && userRole !== 'employeePlace' && (
            <CustomButton
              iconSrc={isMobile ? plusIcon : ''}
              className={styles.addSiteBtn}
              title={isMobile ? '' : 'Создать зал'}
              type='button'
              onClick={() => setModal(true)}
            />
          )}
        </div>
        {(userRole === 'superAdmin' || userRole === 'admin') && (
          <div className={styles.filterContainer}>
            <SearchPanel currentPage={currentPage} />
          </div>
        )}
        {isLoading ? (
          <Loader />
        ) : eventList.length !== 0 ? (
          <EventsList
            eventList={eventList}
            pageSize={placesPerPage}
            bookingData={location?.state ? location.state : null}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalCountPages={places.totalCount}
          />
        ) : (
          <div>Список залов пуст...</div>
        )}
      </div>

      <CustomModal visible={modal} setVisible={setModal}>
        <CreatePlatform onClickHandler={() => setModal(false)} />
      </CustomModal>
    </div>
  )
}

export default PlatformManagementPage
